import React, { useState, useEffect } from "react";
import "./index.m.css";

export const SupportStrip = ({
  message = "ನಿಮ್ಮ ಚಂದಾದಾರಿಕೆಯನ್ನು ಸಕ್ರಿಯಗೊಳಿಸಲಾಗುತ್ತಿದೆ. ಇದು ಕೆಲಸ ನಿಮಿಷಗಳನ್ನು ತೆಗೆದುಕೊಳ್ಳಲಿದೆ. ಸಮಸ್ಯೆಗಳಿದ್ದಲ್ಲಿ ಸಂಪರ್ಕಿಸಿ:",
  email = "support@prajavani.net",
  subject = "I need help with my Subscription",
  body = "Hi, I need help with my subscription.",
  showSecondaryHeader = true,
  isSubscribePage = false,
}) => {
  const [isMobile, setIsMobile] = useState(false);
  const [topOffset, setTopOffset] = useState(isSubscribePage ? 0 : 63);
  const [isFixed, setIsFixed] = useState(false);

  useEffect(() => {
    const updateOffset = () => {
      if (typeof window !== "undefined") {
        const mobile = window.innerWidth < 769;
        setIsMobile(mobile);

        if (mobile) {
          // Mobile: 49px for primary header, 82px if secondary shown
          setTopOffset(showSecondaryHeader ? 82 : 49);
        } else {
          // Desktop: 62px for primary, 107px if secondary shown
          setTopOffset(showSecondaryHeader ? 107 : 62);
        }
      }
    };

    !isSubscribePage && updateOffset();
    window.addEventListener("resize", updateOffset);
    return () => window.removeEventListener("resize", updateOffset);
  }, [showSecondaryHeader]);

  useEffect(() => {
    if (typeof window === "undefined" || isSubscribePage) return;

    const handleScroll = () => {
      setIsFixed(window.scrollY > 0);
    };

    handleScroll();
    window.addEventListener("scroll", handleScroll, { passive: true });
    return () => window.removeEventListener("scroll", handleScroll);
  }, [isSubscribePage]);

  const mailtoHref = `mailto:${email}?subject=${encodeURIComponent(subject)}&body=${encodeURIComponent(body)}`;

  return (
    <div
      styleName="supportStrip"
      style={{
        top: isFixed && isMobile ? 0 : `${topOffset}px`,
        position: isSubscribePage ? "sticky" : isFixed ? "fixed" : "sticky",
        left: isSubscribePage ? undefined : 0,
        right: isSubscribePage ? undefined : 0,
        zIndex: isFixed && isMobile ? 10 : 9,
      }}
      role="note"
      aria-label="Subscription support contact"
    >
      <span styleName="supportMessage">{message}</span>
      <a styleName="supportLink" href={mailtoHref} target="_blank" rel="noopener noreferrer">
        {email}
      </a>
    </div>
  );
};
